import QueryString from 'query-string';
import axios from 'axios';
import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

// TLC(FETCH): Check how data is loaded to add the Total Landed Cost.
// TLC: PEPPERMINT-642(FETCH): 5.2 CCHs
export const fetchLotsForRequest = (id, params = {}, cancelTokenSource = {}) => {
  const stringParams = QueryString.stringify(params);
  const url = ApiUrl(`/bid_requests/${id}/lots?${stringParams}`);

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys:
        {
          pagy: 'pagy',
          qualified_supplier_counts: 'qualified_supplier_counts',
          records: 'records'
        },
    },
    undefined,
    undefined,
    cancelTokenSource
  );
};

// TLC(FETCH): Check how data is loaded to add the Total Landed Cost.
export const fetchResponseLotsForRequest = (bidRequestId, bidResponseId, params = {}, cancelTokenSource) => (
  fetchLotsForRequest(
    bidRequestId,
    {
      ...params,
      bid_response_id: bidResponseId,
      ignore_filter_fields: true,
      lots_type: 'response_lots'
    },
    cancelTokenSource
  )
);

// TLC(FETCH): Check how data is loaded to add the Total Landed Cost.
export const fetchAnchorPriceLotsForRequest = (bidRequestId, vendorOrgId, params = {}, cancelTokenSource) => (
  fetchLotsForRequest(
    bidRequestId,
    {
      ...params,
      ignore_filter_fields: true,
      lots_type: 'anchor_price_lots',
      vendor_organization_id: vendorOrgId,
    },
    cancelTokenSource
  )
);

// TLC(FETCH): Check how data is loaded to add the Total Landed Cost.
export const fetchLineItemsForLot = (bidRequestId, id, params = {}, cancelTokenSource = {}) => {
  const stringParams = QueryString.stringify(params);
  const url = ApiUrl(`/bid_requests/${bidRequestId}/lots/${id}/line_items?${stringParams}`);

  return Call(
    'get',
    url,
    { cancelToken: cancelTokenSource.token },
    ParseGeneralResponse,
    {
      responseDataKeys:
        {
          pagy: 'pagy',
          records: 'records',
        },
    },
    undefined,
    undefined,
    cancelTokenSource
  );
};

// TLC(FETCH): Check how data is loaded to add the Total Landed Cost.
export const fetchResponseLineItemsForLot = (
  bidRequestId,
  id,
  bidResponseId,
  // eslint-disable-next-line default-param-last
  params = {},
  cancelTokenSource,
) => (
  fetchLineItemsForLot(
    bidRequestId,
    id,
    {
      ...params,
      bid_response_id: bidResponseId,
      ignore_filter_fields: true,
      include_award_info: true,
      line_item_type: 'response_line_items',
    },
    cancelTokenSource
  )
);

// TLC(FETCH): Check how data is loaded to add the Total Landed Cost.
export const fetchAnchorPriceLineItemsForLot = (bidRequestId, id, vendorOrgId, params = {}, cancelTokenSource) => (
  fetchLineItemsForLot(
    bidRequestId,
    id,
    {
      ...params,
      ignore_filter_fields: true,
      line_item_type: 'anchor_price_line_items',
      vendor_organization_id: vendorOrgId,
    },
    cancelTokenSource
  )
);

/**
 * Apply a single set of custom header changes across all lots on a request
 * @param {Number} requestId
 * @param {Object} headerChanges Changes made to the headers at a request level (not lot-level)
 */
// TLC: PEPPERMINT-642(SAVE)
export const updateCustomColumnHeaders = (bidRequestId, headerChanges = {}) => {
  // TLC: PEPPERMINT-642(SAVE): CCHs, We need to add the lot_id we want to update
  const url = ApiUrl(`/bid_requests/${bidRequestId}/lots/custom_column_headers`);

  return Call(
    'put',
    url,
    { header_changes: headerChanges },
    ParseGeneralResponse,
    {
      responseDataKeys:
        {
          header_errors: 'header_errors'
        },
    }
  );
};

export const updateUiConfig = (bidRequestId, uiConfigChanges = {}) => {
  const url = ApiUrl(`/bid_requests/${bidRequestId}/lots/update_ui_config`);

  return axios.put(url, { ui_config_changes: uiConfigChanges });
};

export const updateSupplierQuantityEnabled = (bidRequestId, value) => {
  const url = ApiUrl(`/bid_requests/${bidRequestId}`);

  return axios.put(url, { supplier_quantity_enabled: value });
};

export const updateServeSingleSupplierQuoteFeedback = (bidRequestId, value) => {
  const url = ApiUrl(`/bid_requests/${bidRequestId}`);

  return axios.put(url, { serve_single_supplier_quote_feedback: value });
};

// Bulk-update endpoint powering the Line Item Settings drawer. Consolidates
// ui_config lot flags and supplier_quantity_enabled into a single PUT so the
// drawer's Apply commits atomically without firing multiple toasts.
export const updateLineItemSettings = (bidRequestId, payload) => {
  const url = ApiUrl(`/bid_requests/${bidRequestId}`);

  return axios.put(url, payload);
};
